import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './i18n'; // app-wide i18n (EN primary, DE first secondary)
import App from './App';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import PushService from './services/PushService';
import AppUpdateService from './services/AppUpdateService';

// Global error handler for Monaco cancellation errors
window.addEventListener('unhandledrejection', (event) => {
  // Handle Monaco editor cancellation errors gracefully
  if (event.reason && event.reason.message && event.reason.message.includes('Canceled')) {
    console.log('🔄 Monaco operation cancelled gracefully (global handler)');
    event.preventDefault(); // Prevent the error from being logged as uncaught
  }
});

// Global error handler for synchronous Monaco errors
window.addEventListener('error', (event) => {
  // Handle Monaco editor cancellation errors gracefully
  if (event.error && event.error.message && event.error.message.includes('Canceled')) {
    console.log('🔄 Monaco operation cancelled gracefully (global sync handler)');
    event.preventDefault(); // Prevent the error from being logged as uncaught
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Temporarily disabled StrictMode to fix input lag
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
); 

// Native platform setup — location permissions are now deferred to the
// prominent disclosure flow (BackgroundLocationDisclosure) as required by
// Google Play's User Data policy.
try {
  if (Capacitor?.isNativePlatform?.()) {
    PushService.init().catch(() => {});
    AppUpdateService.init()
      .then(() => AppUpdateService.checkForUpdates({ force: true, source: 'launch' }))
      .catch(() => {});
    
    // Handle Android hardware back button
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        // At root of navigation - minimize app instead of exiting
        CapacitorApp.minimizeApp();
      }
    });

    CapacitorApp.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) return;
      AppUpdateService.checkForUpdates({ source: 'resume' }).catch(() => {});
      // Proactively revalidate auth so a stale token is caught on resume
      // rather than silently breaking every subsequent API call.
      window.dispatchEvent(new CustomEvent('auth:check-token'));
    });
  }
} catch (_) {}